// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('projectActivityTypes', {
//         templateUrl: 'views/components/views/projectActivityTypes/projectActivityTypes.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'projectActivityTypesService', function ($stateParams, utilityService, projectActivityTypesService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let projectKeyno = $stateParams.project_keyno;

//             vm.model = {
//                 setting: {},
//                 itemsListProjectActivityTypes: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await projectActivityTypesService.getProjectActivityTypes({ project_keyno: projectKeyno }))[0];
//             }

//             async function loadProjectActivityTypes() {
//                 if (utilityService.validateParmsValue(vm.model.setting.project_keyno) !== true) return;
                
//                 return vm.model.itemsListProjectActivityTypes = await projectActivityTypesService.listProjectActivityTypes({ project_keyno: vm.model.setting.project_keyno });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadProjectActivityTypes();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
